import { createRouter, createWebHistory } from 'vue-router';
// import VConsole from 'vconsole';
// new VConsole();
const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('./index.vue'),
    redirect: 'report',
    children: [
      {
        path: 'report',
        name: 'report',
        component: () => import('./report.vue')
      },
      // {
      //   path: 'progress',
      //   name: 'progress',
      //   component: () => import('./progress.vue')
      // },
      {
        path: 'newslist',
        name: 'newslist',
        component: () => import('./newslist.vue')
      },
      {
        path: 'detail',
        name: 'detail',
        component: () => import('./detail.vue')
      },
      {
        path: 'news-category',
        name: 'newsCategory',
        component: () => import('./news-category.vue')
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('./about.vue')
      }
    ]
  }
];
const router = createRouter({
  history: createWebHistory('/2021/netaccuse'),
  routes
});

export default router;
